import is from '@sindresorhus/is';
import { useEffect } from 'react';

import { useActiveThreadStore } from './ActiveThreadStoreProvider';

const INSIDE_SELECTOR = [
    '[data-anchor-kind="title"]',
    '[data-anchor-kind="skill"]',
    '[data-comment-button]',
    '[data-comment-id]',
    '[data-comment-composer]',
    'mark[data-comment-id]',
    '[role="menu"]',
    '[role="dialog"]',
].join(',');

export const useDeactivateOnOutsideClick = (): void => {
    const setActiveThreadId = useActiveThreadStore((state) => state.setActiveThreadId);
    const cancelPending = useActiveThreadStore((state) => state.cancelPending);

    useEffect(() => {
        const handleMouseDown = (event: MouseEvent): void => {
            const target = event.target;
            if (!(target instanceof Element)) return;
            if (!is.null(target.closest(INSIDE_SELECTOR))) return;
            setActiveThreadId(null);
            cancelPending();
        };
        document.addEventListener('mousedown', handleMouseDown);
        return () => {
            document.removeEventListener('mousedown', handleMouseDown);
        };
    }, [setActiveThreadId, cancelPending]);
};
